import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ condition, children, redirect }) {
  if (!condition) {
    return <Navigate to={redirect} replace />;
  }

  return children;
}
